import React from 'react';
import { courses } from '../data/courses';
import CourseCard from '../components/CourseCard';
import copy from '../copy';

const Courses: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">{copy.cursos_titulo}</h1>
        <p className="text-gray-600 mb-8">{copy.cursos_subtitulo}</p>
        <div className="mb-6 text-sm text-primary-600 font-medium">
          {courses.length} {copy.cursos_encontrados}
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {courses.map((course) => (
            <CourseCard key={course.id} course={course} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Courses; 